/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useEffect } from 'react'

import './edit-package.scss'
import { BaseDrawer } from '@/components/drawer/base-drawer'
import { layerManage, showLayer } from '@/utils/layer'
import { Formik, FormikProps, Form } from 'formik'
import { IPakageForm, IPakageFormErrors } from './package-type'
import { Column, Row } from '@/components/layout/layout'
import { getBEMCls } from '@/utils/classname'
import FormTitle from '@/views/main/modules/goods-manage/components/form/form-title/form-title'
import Input from '@/components/input/input'
import FormItem from '@/views/main/modules/goods-manage/components/form/form-item/form-item'
import Cascader from '@/components/input/cascader'
import { GoodsModel, goodsModel } from '../edit-goods/modules/model'
import { observer } from 'mobx-react'
import AddGoodTable from './modules/form/add-good-table'
import $msg from '@/utils/message'
import PriceTable from './modules/form/price-table'
import { GoodsSupplierFormItem } from '../edit-goods/modules/form/supplier'
import BarcodeInput from './modules/form/barcode-input'
import classNames from 'classnames'
import Iconfont from '@/components/iconfont/iconfont'
import { Image, Spin } from 'antd'
import { ChooseMaterialDialog } from '../../../../components/material-library/choose-material-dialog'
import { getQiniuImgUrl } from '@/config/qiniu'
import Button from '@/components/button/button'
import Radio from 'formik-antd/lib/radio'
import Switch from 'formik-antd/lib/switch'
import AntdSwitch from 'antd/lib/switch'
import { getErrorStr, checkError, checkValidate } from '@/utils/form'
import { useRequest } from 'ahooks'
import { $post } from '@/api'
import { goodsLibraryStore } from '../../store/goods-library'
import { get, uniqBy, INPUT_NUMBER_LIMIT_REGEXP, INPUT_PRICE_LIMIT_REGEXP } from '@/utils'
import SelectGoods, { useSelectGoods } from '../../../../components/select-goods/select-goods'

interface EditPackageProps {
    goodsModel: GoodsModel
    packageId?: number
    mode?: 'add' | 'edit'
}

const EditPackage: React.FC<EditPackageProps> = observer(props => {
    const formikRef = useRef<FormikProps<IPakageForm>>(null)
    const formInitValues: IPakageForm = {
        name: '',
        img_url: '',
        goods_code: '',
        supplier_ids: [],
        groups: [],
        barcodes: [''],
        extra_point: '',
        group_id: 0,
        secondary_group_id: 0,
        on_cashier: true,
        on_mall: true,
        point_status: 0,
        package_goods_list: [],
        pricing_methods: [
            {
                member_price: { sale_price: '', sale_unit: 2 },
                sale_prices: [{ sale_price: '', sale_unit: 2, threshold: 0 }],
                sales_unit: { id: 2, name: '斤', status: 0 },
                sales_unit_id: 2,
                sales_unit_ratio: 1,
                id: null,
            },
        ],
        stock_deduction_mode: 0,
        participate_discount: 0,
    }
    const cls = (...args: string[]) => getBEMCls('edit-package', ...args)
    const [isKeepAdd, setKeepAddStatus] = useState<boolean>(true)
    const [unit, setUnit] = useState<string>('套')
    const [unitId, setUnitId] = useState<number>(23)

    const { initGoods } = useSelectGoods()

    const getPackageDetail = useRequest(
        (id: number) =>
            $post({
                url: '/goods/getsinglegoods',
                params: {
                    desc: true,
                    goods_id: id,
                    order_by: 'goods_id',
                },
            }),
        {
            manual: true,
            onSuccess: res => {
                if (formikRef.current) {
                    const values = {
                        ...res,
                        supplier_ids: res.suppliers.map((val: any) => val.id),
                        groups: [res.group.id, res.secondary_group.id],
                        group: undefined,
                        secondary_group: undefined,
                        suppliers: undefined,
                        goods_package: undefined,
                        goods_id: res.id,
                        on_cashier: res.status === 0,
                        pricing_methods: [
                            {
                                ...res.pricing_methods[0],
                                sales_unit_id: res.pricing_methods[0].sales_unit.id,
                                member_price: Object.keys(res.pricing_methods[0].member_price).length
                                    ? {
                                          ...res.pricing_methods[0].member_price,
                                          sale_unit: res.pricing_methods[0].member_price.sale_unit.id,
                                      }
                                    : {},
                                sale_prices: res.pricing_methods[0].sale_prices.map((i: any) => ({
                                    ...i,
                                    sale_unit: i.sale_unit.id,
                                })),
                            },
                        ],
                        package_goods_list: res.goods_package.map((i: any) => ({
                            ...i.goods,
                            amount: i.amount,
                            price: i.price,
                            sales_unit: i.unit,
                            stock_unit: i.unit,
                            id: i.id,
                            goods_id: i.goods.id,
                        })),
                        point_status: res.goodspointconfig.status,
                        extra_point: res.goodspointconfig.extra_point,
                    }
                    initGoods(res.goods_package.map((i: any) => i.goods))
                    setUnit(res.stock_unit.name)
                    setUnitId(res.stock_unit.id)
                    formikRef.current.setValues(values)
                }
            },
        },
    )

    useEffect(() => {
        // 编辑套餐获取套餐详情
        props.packageId && getPackageDetail.run(props.packageId)
    }, [props.packageId])

    useEffect(() => {
        // 初始化商品需要的信息
        goodsModel.init(true).then(() => {
            // 初始选择默认分组
            const defaultGroup = goodsModel.goodsGroup.find(val => val.is_default)
            if (props.mode === 'add' && formikRef.current) {
                formikRef.current.setFieldValue('groups', [
                    defaultGroup?.id,
                    get(defaultGroup, 'secondary_group[0].id', void 0),
                ])
                formikRef.current.setFieldValue('goods_code', goodsModel.generateCode?.new_code)
            }
        })
    }, [])

    const addOrUpdatePackage = useRequest(
        params =>
            $post({
                url: `/goods/${props.mode === 'edit' ? 'editpackage' : 'addpackage'}`,
                params,
            }),
        {
            manual: true,
            onSuccess: () => {
                $msg('success', '添加成功')
                layerManage.pop()
                goodsLibraryStore.resetGoodTableData()
            },
            onError: e => {
                $msg('error', e.message)
            },
        },
    )

    const onSubmit = (val: IPakageForm) => {
        const packageList = val.package_goods_list.map(i => ({
            goods_id: i.id,
            price: i.price || i.pricing_methods[0].sale_prices[0].sale_price,
            unit_id: i.stock_unit.id,
            amount: i.amount,
            pricing_method_id: i.pricing_methods[0].id,
        }))
        const params = {
            ...val,
            package_goods_list: packageList,
            group_id: val.groups[0],
            secondary_group_id: val.groups[1],
            participate_discount: val.participate_discount ? 1 : 0,
            extra_point: val.extra_point || 0,
            barcodes: val.barcodes[0] ? val.barcodes : void 0,
            pricing_methods: [
                {
                    ...val.pricing_methods[0],
                    member_price: val.pricing_methods[0].member_price.sale_price
                        ? val.pricing_methods[0].member_price
                        : void 0,
                },
            ],
        }
        addOrUpdatePackage.run(params)
    }

    return (
        <BaseDrawer isShow title={`${props.mode === 'edit' ? '编辑' : '新建'}套餐`} onClose={() => layerManage.pop()}>
            <Formik
                validateOnBlur
                innerRef={formikRef}
                initialValues={formInitValues}
                onSubmit={onSubmit}
                validate={validateForm}
            >
                {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => {
                    return (
                        <Form data-height-100p>
                            <Column data-height-100p>
                                <div data-expaned data-overflow-auto className={cls()}>
                                    <Spin spinning={getPackageDetail.loading}>
                                        <FormTitle title="基本信息" />
                                        <FormItem isRequire title="套餐名" error={getErrorStr('name', errors, touched)}>
                                            <Input
                                                error={checkError('name', errors, touched)}
                                                name="name"
                                                type="text"
                                                maxLength={30}
                                                value={values.name}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                placeholder="输入套餐名称"
                                                inputsuffix={() => (
                                                    <span data-font-size-14 data-color-000>
                                                        {values.name.length}/30
                                                    </span>
                                                )}
                                            />
                                        </FormItem>
                                        <FormItem title="套餐分组">
                                            <Cascader
                                                placeholder="请选择"
                                                name="groups"
                                                options={props.goodsModel.goodsGroup}
                                                fieldNames={{
                                                    label: 'name',
                                                    value: 'id',
                                                    children: 'secondary_group',
                                                }}
                                                inputsuffix={() => (
                                                    <i data-color-999 className="iconfont icon6xiala2-202"></i>
                                                )}
                                            />
                                        </FormItem>
                                        <FormTitle title="单品设置">
                                            <div
                                                data-padding-right-24
                                                className="action"
                                                onClick={() => {
                                                    showLayer(
                                                        <SelectGoods
                                                            onSubmit={goods => {
                                                                const formatGoods = goods.map(i => ({
                                                                    ...i,
                                                                    goods_id: i.id,
                                                                    price:
                                                                        i.pricing_methods[0].sale_prices[0].sale_price,
                                                                    unit_id:
                                                                        i.pricing_methods[0].sale_prices[0].sale_unit
                                                                            .id,
                                                                    amount: 0,
                                                                    pricing_method_id: i.pricing_methods[0].id,
                                                                }))

                                                                const setGoods = uniqBy(
                                                                    [...values.package_goods_list, ...formatGoods],
                                                                    'goods_id',
                                                                )

                                                                setFieldValue(
                                                                    'package_goods_list',
                                                                    JSON.parse(JSON.stringify(setGoods)),
                                                                )
                                                            }}
                                                        />,
                                                    )
                                                }}
                                            >
                                                +添加商品
                                            </div>
                                        </FormTitle>

                                        <AddGoodTable />

                                        <FormTitle title="售价设置" />
                                        <PriceTable
                                            saleUnitId={unitId}
                                            pricingMethodIndex={0}
                                            saleUnitName={unit}
                                            onUnitChange={unit => setUnit(unit)}
                                        />
                                        <FormItem
                                            title="会员价"
                                            error={getErrorStr('pricing_methods[0].member_price', errors, touched)}
                                        >
                                            <Input
                                                error={checkError('pricing_methods[0].member_price', errors, touched)}
                                                name="pricing_methods[0].member_price.sale_price"
                                                type="text"
                                                value={values.pricing_methods[0].member_price.sale_price || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                reg={INPUT_PRICE_LIMIT_REGEXP}
                                                placeholder="输入会员价"
                                                inputsuffix={() => (
                                                    <span data-font-size-14 data-color-000>
                                                        元/{unit}
                                                    </span>
                                                )}
                                            />
                                        </FormItem>
                                        <FormTitle title="其他信息" />
                                        {/* 供货商 */}
                                        <GoodsSupplierFormItem goodsModel={props.goodsModel}></GoodsSupplierFormItem>

                                        <FormItem
                                            isRequire
                                            title="商品编码"
                                            error={getErrorStr('goods_code', errors, touched)}
                                        >
                                            <Input
                                                reg={/^\d{0,18}$/}
                                                error={checkError('goods_code', errors, touched)}
                                                name="goods_code"
                                                value={values.goods_code}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                placeholder="请输入"
                                                inputsuffix={() => {
                                                    return (
                                                        <Row data-algin-items-center>
                                                            <span data-font-size-14 data-color-000>
                                                                {values.goods_code.length}/18
                                                            </span>
                                                        </Row>
                                                    )
                                                }}
                                            ></Input>
                                        </FormItem>

                                        <BarcodeInput />

                                        <FormItem title="商品图片">
                                            <Row
                                                data-align-items-center
                                                data-expaned
                                                data-position-relative
                                                onClick={() => {
                                                    showLayer(
                                                        <ChooseMaterialDialog
                                                            onSelected={data => {
                                                                layerManage.pop()
                                                                setFieldValue('img_url', data.url)
                                                            }}
                                                        ></ChooseMaterialDialog>,
                                                    )
                                                }}
                                            >
                                                {values.img_url ? (
                                                    <div className={cls('img')}>
                                                        <Image
                                                            src={getQiniuImgUrl(values.img_url)}
                                                            width={60}
                                                            height={60}
                                                            onClick={e => {
                                                                e.stopPropagation()
                                                            }}
                                                        />
                                                        <div
                                                            className={cls('img', 'delete')}
                                                            onClick={e => {
                                                                e.stopPropagation()
                                                                setFieldValue('img_url', '')
                                                            }}
                                                        >
                                                            <Iconfont name="icon3shanchu-20" size={20}></Iconfont>
                                                        </div>
                                                        <div
                                                            className={cls('img', 'change')}
                                                            onClick={e => {
                                                                e.stopPropagation()
                                                                showLayer(
                                                                    <ChooseMaterialDialog
                                                                        onSelected={data => {
                                                                            layerManage.pop()
                                                                            setFieldValue('img_url', data.url)
                                                                        }}
                                                                    ></ChooseMaterialDialog>,
                                                                )
                                                            }}
                                                        >
                                                            更换
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <Column
                                                        className={classNames(cls('img'), cls('img', 'border'))}
                                                        data-center
                                                    >
                                                        <Iconfont name="icon6shangchuan-24" size={24}></Iconfont>
                                                        <div data-font-size-12 data-color-999>
                                                            素材库
                                                        </div>
                                                    </Column>
                                                )}
                                            </Row>
                                        </FormItem>

                                        <FormTitle title="高级设置" />

                                        <Row
                                            data-align-items-center
                                            data-padding-h-24
                                            data-margin-top-16
                                            data-height-50
                                        >
                                            <span className={classNames(cls('form-item', 'title'))}>积分</span>
                                            <Radio.Group name="point_status" value={values.point_status}>
                                                <Radio name="point_status" value={0}>
                                                    不参与积分赠送
                                                </Radio>
                                                <Radio name="point_status" value={1}>
                                                    正常积分
                                                </Radio>
                                                <Radio name="point_status" value={2}>
                                                    额外积分
                                                </Radio>
                                            </Radio.Group>
                                        </Row>

                                        {values.point_status === 2 && (
                                            <FormItem
                                                title="额外积分"
                                                error={getErrorStr('extra_point', errors, touched)}
                                            >
                                                <Input
                                                    error={checkError('extra_point', errors, touched)}
                                                    name="extra_point"
                                                    value={values.extra_point}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    placeholder="请输入额外积分"
                                                    type="number"
                                                ></Input>
                                            </FormItem>
                                        )}

                                        <Row data-align-items-center data-padding-h-24 data-height-50>
                                            <span data-width-84 className={classNames(cls('form-item', 'title'))}>
                                                参与店铺优惠
                                            </span>
                                            <Row
                                                data-align-items-center
                                                data-justify-content-space-between
                                                data-expaned
                                                data-position-relative
                                            >
                                                <span data-font-size-12 data-color-999>
                                                    包括会员日折扣、手动整单折扣
                                                </span>
                                                <Switch name="participate_discount"></Switch>
                                            </Row>
                                        </Row>

                                        <Row data-align-items-center data-padding-h-24 data-height-50>
                                            <span data-width-112 className={classNames(cls('form-item', 'title'))}>
                                                默认库存扣减方式
                                            </span>
                                            <Row
                                                data-align-items-center
                                                data-justify-content-flex-end
                                                data-expaned
                                                data-position-relative
                                            >
                                                <Radio.Group name="stock_deduction_mode">
                                                    <Radio name="stock_deduction_mode" value={0}>
                                                        付款减库存
                                                    </Radio>
                                                    <Radio name="stock_deduction_mode" value={1}>
                                                        拍下减库存
                                                    </Radio>
                                                </Radio.Group>
                                            </Row>
                                        </Row>
                                    </Spin>
                                </div>

                                <Row data-justify-content-space-between className={cls('footer')}>
                                    <Row>
                                        <AntdSwitch
                                            checked={isKeepAdd}
                                            onChange={val => {
                                                setKeepAddStatus(val)
                                            }}
                                        ></AntdSwitch>
                                        <span data-padding-left-10 data-font-size-14 data-font-weight-600>
                                            连续添加
                                        </span>
                                        <div className={cls('line')}></div>
                                        <Row>
                                            <span data-color-999 data-font-size-14 data-margin-right-8>
                                                上架到
                                            </span>
                                            <Row
                                                data-cursor-pointer
                                                data-align-items-center
                                                onClick={() => {
                                                    setFieldValue('on_mall', !values.on_mall)
                                                }}
                                            >
                                                <Iconfont
                                                    name={
                                                        values.on_mall
                                                            ? 'icon3duoxuanquanxuan-20'
                                                            : 'icon3duoxuanguan-20'
                                                    }
                                                    size={20}
                                                ></Iconfont>
                                                <span data-margin-left-8>商城货架</span>
                                            </Row>
                                            <Row
                                                data-cursor-pointer
                                                data-align-items-center
                                                data-margin-left-10
                                                onClick={() => {
                                                    setFieldValue('on_cashier', !values.on_cashier)
                                                }}
                                            >
                                                <Iconfont
                                                    name={
                                                        values.on_cashier
                                                            ? 'icon3duoxuanquanxuan-20'
                                                            : 'icon3duoxuanguan-20'
                                                    }
                                                    size={20}
                                                ></Iconfont>
                                                <span data-margin-left-8>收银台</span>
                                            </Row>
                                        </Row>
                                    </Row>
                                    <Button
                                        loading={addOrUpdatePackage.loading || void 0}
                                        type="submit"
                                        types="default"
                                    >
                                        确认添加
                                    </Button>
                                </Row>
                            </Column>
                        </Form>
                    )
                }}
            </Formik>
        </BaseDrawer>
    )
})

EditPackage.defaultProps = {
    mode: 'add',
}

export default EditPackage

function validateForm(values: IPakageForm) {
    const errors: IPakageFormErrors = {
        pricing_methods: [],
        barcodes: [],
    }

    if (values.name.trim().length === 0) {
        errors.name = '请输入套餐名'
    }

    values.pricing_methods.forEach((pricingMethod, priceingMethodIndex) => {
        errors.pricing_methods.push({
            sale_prices: [],
            barcodes: [],
        })

        pricingMethod.sale_prices.forEach((value, salePriceIndex, arr) => {
            errors.pricing_methods[priceingMethodIndex].sale_prices.push({})
            if (arr[salePriceIndex - 1]) {
                if (+value.threshold < +arr[salePriceIndex - 1].threshold) {
                    errors.pricing_methods[priceingMethodIndex].sale_prices[salePriceIndex].threshold = '应大于上一级'
                }

                if (+value.sale_price > +arr[salePriceIndex - 1].sale_price) {
                    errors.pricing_methods[priceingMethodIndex].sale_prices[salePriceIndex].sale_price = '应小于上一级'
                }
            }

            if (value.sale_price.toString().trim().length === 0) {
                errors.pricing_methods[priceingMethodIndex].sale_prices[salePriceIndex].sale_price = '请输入价格'
            }

            if (value.threshold.toString().trim().length === 0) {
                errors.pricing_methods[priceingMethodIndex].sale_prices[salePriceIndex].threshold = '请输入购买量'
            }
        })
    })

    if (+values.pricing_methods[0].member_price.sale_price > +values.pricing_methods[0].sale_prices[0].sale_price) {
        errors.pricing_methods[0].member_price = '会员价需小于零售价'
    }

    if (values.package_goods_list.length < 2) {
        errors.package_goods_list = '套餐中的商品种类至少为2种'
    }

    if (values.point_status === 2 && !values.extra_point.toString().trim().length) {
        errors.extra_point = '请输入额外积分'
    }

    if (values.goods_code.toString().trim().length === 0) {
        errors.goods_code = '请输入商品编码'
    }

    values.barcodes.forEach(val => {
        const str = val.length > 0 && val.length < 8 ? '条码需大于8位' : ''
        errors.barcodes.push(str)
    })

    if (checkValidate(errors)) {
        return {}
    }

    return errors
}
